import React, { Fragment, useContext } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import Auth from "../utils/cookies.config";
import { PartnerContext } from "../utils/UserContext";
import Influencer from "../screens/Influencer";
import LoyaltyVerification from "../screens/LoyaltyVerification";

const PrivateRoute = ({ component: Component, path, name, exact }) => {
  const user = useContext(PartnerContext);

  const { pathname } = useLocation();

  return (
    <Fragment>
      {/* <Redirect from={"/"} to={"/dashboard"} /> */}
      <Route
        path={path}
        exact={exact}
        // name={name}
        render={(props) => {
          let token = Auth.getCipher();
          if (pathname === "/influencer" && !token) {
            return <Influencer />;
          } else if (pathname === "/loyalty-verification" && !token) {
            return <LoyaltyVerification />;
          } else if (!token) {
            return <Redirect to={{ pathname: "/login" }} />;
          } else {
            return <Component />;
          }
        }}
      />
    </Fragment>
  );
};

export default PrivateRoute;
